import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// الرابط الأساسي حسب الصورة
const API_URL = `${process.env.REACT_APP_API_BASE_URL}assessment-criteria/list`;

// 1️⃣ إنشاء الثانك (Thunk) لجلب الطلاب من السيرفر
export const fetchStudents = createAsyncThunk(
  "students/fetchStudents",
  async ({ classId, schoolId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_URL, {
        params: {
          classId: classId,
          schoolId: schoolId,
        },
      });
      
      // إرجاع البيانات للـ Reducer ليتعامل معها
      return response.data;
    } catch (error) {
      console.error("❌ خطأ أثناء جلب بيانات الطلاب:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "فشل في جلب بيانات الطلاب من السيرفر"
      );
    }
  }
);

// 2️⃣ إنشاء الـ Slice
const studentsSlice = createSlice({
  name: "students",
  initialState: {
    studentsList: [],
    fetchStatus: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    fetchError: null,
  },
  reducers: {
    // تصفير حالة الخطأ والتحميل
    resetStudentsState: (state) => {
      state.fetchStatus = "idle";
      state.fetchError = null;
    },
    // تفريغ قائمة الطلاب (مفيد عند تسجيل الخروج أو تغيير المادة)
    clearStudentsList: (state) => {
      state.studentsList = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudents.pending, (state) => {
        state.fetchStatus = "loading";
        state.fetchError = null;
      })
      .addCase(fetchStudents.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        
        // التعامل المرن مع شكل الاستجابة لاستخراج مصفوفة الطلاب
        const data = action.payload;
        let studentsArray = [];
        if (Array.isArray(data)) studentsArray = data;
        else if (data?.data && Array.isArray(data.data)) studentsArray = data.data;
        else if (data?.students && Array.isArray(data.students)) studentsArray = data.students;
        
        state.studentsList = studentsArray;
      })
      .addCase(fetchStudents.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.fetchError = action.payload;
      });
  },
});

// 3️⃣ تصدير الأكشنز العادية
export const { resetStudentsState, clearStudentsList } = studentsSlice.actions;

// 4️⃣ تصدير محددات البيانات (Selectors)
export const selectStudentsList = (state) => state.students.studentsList;
export const selectStudentsStatus = (state) => state.students.fetchStatus;
export const selectStudentsError = (state) => state.students.fetchError;

// 5️⃣ تصدير الـ Reducer الافتراضي لإضافته في الـ Store
export default studentsSlice.reducer;